// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__11E5V","alert":"SettungsInbox_alert__BLbpc"};